<template>
  <sidebar
  :addTitle="$t('Decarbonization.EnergySourceUnitConversion.AddNew')"
  :editTitle="$t('Decarbonization.EnergySourceUnitConversion.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('Decarbonization.EnergySourceUnitConversion.EnergySource')" rules="required" v-slot="{ errors }">
              <v-select
                :options="energySources"
                label="name"
                :reduce="energy => energy.id"
                v-model="energySource"
                class="w-full"
                name="energySourceId"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.EnergySourceUnitConversion.GramPerLiter')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.EnergySourceUnitConversion.GramPerLiter')"
              v-model="gramPerLiter"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Decarbonization.EnergySourceUnitConversion.GJPerCubicMeter')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('Decarbonization.EnergySourceUnitConversion.GJPerCubicMeter')"
              v-model="gjPerCubicMeter"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>

import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "@/app/shared/components";

import EnergySourcesEnum from "./../../../enums/EnergySources.js";
import vSelect from 'vue-select';

export default {
  props: {    
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar,
    vSelect
  },
  data() {
    return {
      id: 0,
      energySource: "",
      gramPerLiter: 0.0,
      gjPerCubicMeter: 0.0,
      energySources: [
        { name: this.$t("Decarbonization.EnergySourcesEnum." + EnergySourcesEnum.GridEnergy), id: EnergySourcesEnum.GridEnergy },
        { name: this.$t("Decarbonization.EnergySourcesEnum." + EnergySourcesEnum.DieselPrimeMover), id: EnergySourcesEnum.DieselPrimeMover },
        { name: this.$t("Decarbonization.EnergySourcesEnum." + EnergySourcesEnum.DieselEquipment), id: EnergySourcesEnum.DieselEquipment },
        { name: this.$t("Decarbonization.EnergySourcesEnum." + EnergySourcesEnum.Gasoline), id: EnergySourcesEnum.Gasoline },
        { name: this.$t("Decarbonization.EnergySourcesEnum." + EnergySourcesEnum.NaturalGas), id: EnergySourcesEnum.NaturalGas }
      ]
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { id, energySource, gramPerLiter, gjPerCubicMeter } = JSON.parse(JSON.stringify(this.data));
      this.id = id;
      this.energySource = energySource;
      this.gramPerLiter = gramPerLiter;
      this.gjPerCubicMeter = gjPerCubicMeter;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;      
      this.energySource = "";
      this.id = 0;
      this.gramPerLiter = 0.0;
      this.gjPerCubicMeter = 0.0;
    },    
    
    async submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.id,
            energySource: this.energySource,
            gramPerLiter: this.gramPerLiter,
            gjPerCubicMeter: this.gjPerCubicMeter
          };

          this.$vs.loading();
         
          if (this.id !== null && this.id > 0) {
            this.$store.dispatch("decarbonization/updateEnergySourceUnitConversions", obj).then((result) => {
              this.$emit("onUpdated", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("decarbonization/addEnergySourceUnitConversion", obj).then((result) => {
              this.$emit("onInserted", result.data);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
